const not_authenticated_pt = require('./not_authenticated.json')
export default not_authenticated_pt